var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.92 37.52C59.52 28.29 52.87 25.93 44.65 25.65C36.73 25.39 21.45 23.73 15.47 30.14C12.47 33.4 12.47 37.7 12.31 41.86C12.15 46.02 11.09 51.47 13.15 55.43C17.26 63.32 30.37 61.43 37.7 61.5C39.3071 61.4743 40.8412 60.8244 41.9778 59.6878C43.1143 58.5512 43.7642 57.0171 43.79 55.41C43.8087 53.9222 44.1233 52.453 44.7157 51.0881C45.308 49.7232 46.1661 48.4899 47.24 47.46C49.45 45.38 52.3 45.23 54.66 43.58L54.97 43.33C55.6783 43.2784 56.3692 43.0865 57.0027 42.7655C57.6362 42.4445 58.1996 42.0009 58.6601 41.4603C59.1207 40.9197 59.4692 40.293 59.6855 39.6166C59.9018 38.9402 59.9815 38.2275 59.92 37.52Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0699 30.8801C26.0699 30.8801 23.5799 12.0601 35.5699 12.0601C47.5599 12.0601 45.0799 30.8801 45.0799 30.8801",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1102 57.1501C67.608 59.8186 66.2979 62.2684 64.3575 64.1679C62.4171 66.0673 59.9399 67.3247 57.2613 67.7699C54.5827 68.2151 51.832 67.8266 49.3814 66.657C46.9309 65.4873 44.8989 63.593 43.5604 61.2305C42.222 58.8679 41.6417 56.1512 41.8981 53.4479C42.1545 50.7447 43.2353 48.1855 44.9941 46.1168C46.7529 44.048 49.1049 42.5696 51.7316 41.8816C54.3584 41.1936 57.1331 41.3292 59.6802 42.2701",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2999 60.1001C54.1683 60.1009 54.0379 60.0756 53.916 60.0259C53.7942 59.9761 53.6834 59.9028 53.5899 59.8101L49.4199 55.6401L50.8299 54.2301L54.2999 57.6901L65.6299 46.3501L66.9999 47.7701L54.9999 59.7701C54.911 59.8689 54.8033 59.9489 54.6831 60.0056C54.5629 60.0622 54.4327 60.0944 54.2999 60.1001Z",
    fill: "url(#paint0_linear_47754_26912)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58.4199H22.53C20.997 58.4199 19.5269 57.8109 18.4429 56.7269C17.359 55.643 16.75 54.1728 16.75 52.6399V36.6399C16.75 35.1069 17.359 33.6367 18.4429 32.5528C19.5269 31.4688 20.997 30.8599 22.53 30.8599H48.62C49.3786 30.8599 50.1297 31.0094 50.8304 31.3C51.5311 31.5906 52.1676 32.0165 52.7035 32.5534C53.2395 33.0902 53.6643 33.7275 53.9537 34.4287C54.243 35.1299 54.3913 35.8813 54.39 36.6399",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5703 40.96V48.69",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47754_26912",
    x1: 49.4199,
    y1: 53.2301,
    x2: 67.0399,
    y2: 53.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.c335e02df7657ea05ac05eb30887a0bf.svg";
export { ForwardRef as ReactComponent };